import { render, staticRenderFns } from "./ServiceDevelopmentPlatform.vue?vue&type=template&id=320f637c&scoped=true&"
import script from "./ServiceDevelopmentPlatform.vue?vue&type=script&lang=js&"
export * from "./ServiceDevelopmentPlatform.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDevelopmentPlatform.vue?vue&type=style&index=0&id=320f637c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f637c",
  null
  
)

export default component.exports